var exports = {
  "x": "ReactionsMenuOption__mhKT14",
  "j": "viewerHasReacted__4pEcKI",
};

module.exports = exports;
